import printy6ImageLoader from "@lib/printy6ImageLoader";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Head from "next/head";
import Image from "next/image";
import * as React from "react";
import { Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTemplate } from "../store";

// const Image = styled("img")({
//   width: "100%",
//   cursor: "pointer",
//   position: "relative",
//   fontSize: 0,
//   "&:after": {
//     content: "''",
//     position: "absolute",
//     width: "100%",
//     paddingBottom: "100%",
//     top: 0,
//     left: 0,
//   },
// });

export default function ImagesPreview({
  images,
  activeImageId,
  swiper,
  setSwiper,
  width,
}: {
  images: any[];
  activeImageId: number;
  width: number | string;
  swiper: any;
  setSwiper: any;
}): React.ReactElement {
  const { title } = useTemplate();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <React.Fragment>
      <Head>
        <style
          id="template-thumb-image-swiper-style"
          dangerouslySetInnerHTML={{
            __html: `#thumb-image-wrap .swiper-slide {box-sizing: border-box;font-size: 0;border-color: transparent;}#thumb-image-wrap .swiper-slide-thumb-active {border: 2px solid;border-color: ${theme.palette.primary.main};padding: 3px;}`,
          }}
        />
      </Head>
      <Swiper
        id="thumb-image-wrap"
        onSwiper={setSwiper}
        direction={matches ? "horizontal" : "vertical"}
        slidesPerView="auto"
        spaceBetween={8}
        threshold={8}
        modules={[Thumbs]}
        updateOnWindowResize
        // virtual
      >
        {images.map((image, index) => (
          <SwiperSlide
            key={image.id}
            virtualIndex={index}
            style={matches ? { width } : { height: "auto" }}
          >
            <Box
              sx={{
                fontSize: 0,
                position: "relative",
              }}
            >
              <Image
                width={200}
                height={200}
                src={printy6ImageLoader({ src: image.src, quality: 200 })}
                unoptimized={true}
                alt={`${title} ${index + 1}`}
                loading="lazy"
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </React.Fragment>
  );
}
